import React, { useState } from "react";
import StatusPill from "../../../../components/data-table/StatusPill";
import RowActions from "../../../../components/data-table/RowActions";
import moment from "moment"; // Import moment

// components
import DeleteModal from "./components/delete-modal";
import MessageModal from "./components/message-modal";
import { useDeleteannouncementMutation } from "../../../../store/Reducer/annocements";

// Whether people see it now: published, and today is within its dates.
const STATUS = {
  draft: ["Draft", "gray"],
  hidden: ["Hidden", "gray"],
  scheduled: ["Scheduled", "blue"],
  showing: ["Showing now", "green"],
  ended: ["Ended", "red"],
};
export function announcementStatus(a) {
  if (!a?.isPublished) return "draft";
  // Turned off with the old "Active" box; saving it again shows it.
  if (a.isActive === false) return "hidden";
  if (a.displayFrom && moment().isBefore(a.displayFrom, "day")) return "scheduled";
  if (a.displayUntil && moment().isAfter(a.displayUntil, "day")) return "ended";
  return "showing";
}

export default function TableBodyCustom({ data, index, onEditRow }) {
  const [isOpen, setIsOpen] = useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [deleteannouncement] = useDeleteannouncementMutation(); // Hook to call deleteNews API

  const openModal = (id) => {
    console.log("id", id);
    setSelectedId(id); // Store the selected ID for deletion
    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);

  const openMessageModal = () => setMessageModal(true);
  const closeMessageModal = () => setMessageModal(false);

  const handleDelete = async () => {
    console.log("selectedId", selectedId);

    if (selectedId) {
      try {
        console.log("selectedId", selectedId);
        await deleteannouncement(selectedId).unwrap(); // Call the deleteNews function with the ID
        console.log("Record Deleted");
        closeModal(); // Close the modal after deletion
      } catch (error) {
        console.error("Failed to delete news:", error);
      }
    }
  };

  const status = announcementStatus(data);

  const formattedDisplayFrom = data?.displayFrom ? moment(data.displayFrom).format("D MMM YYYY") : "";
  const formattedDisplayUntil = data?.displayUntil ? moment(data.displayUntil).format("D MMM YYYY") : "";
  const message = data?.text || data?.bannerText;

  return (
    <>
      <tr className="hover:bg-gray-50">
        <td className="px-4 py-3">
          <span className="block font-medium text-gray-900">{data?.title}</span>
          <span className="block text-xs text-gray-500">
            {[data?.type?.includes("banner") && "Banner", data?.type?.includes("special_section") && "Section"].filter(Boolean).join(" · ")}
          </span>
        </td>
        <td className="px-4 py-3 max-w-xs">
          {message ? (
            <button type="button" onClick={openMessageModal} className="line-clamp-2 text-left text-gray-600 hover:text-gray-900" title="Read the whole message">
              {message}
            </button>
          ) : (
            <span className="text-gray-400">—</span>
          )}
        </td>
        <td className="px-4 py-3 whitespace-nowrap text-gray-600">
          {formattedDisplayFrom === formattedDisplayUntil ? formattedDisplayFrom : `${formattedDisplayFrom} – ${formattedDisplayUntil}`}
        </td>
        <td className="px-4 py-3">
          <StatusPill tone={STATUS[status][1]}>{STATUS[status][0]}</StatusPill>
        </td>
        <td className="px-4 py-3">
          <RowActions onEdit={() => onEditRow(data)} onDelete={() => openModal(data?._id)} editLabel="Edit announcement" deleteLabel="Delete announcement" />
        </td>
      </tr>

      <DeleteModal
        isOpen={isOpen}
        title="Are You Sure?"
        desc="This record will be permanently deleted. This action cannot be undone."
        onConfirm={handleDelete} // Pass handleDelete to execute on confirm
        onCancel={closeModal} // Close the modal on cancel
      />

      <MessageModal
        isOpen={messageModal}
        data={message}
        title="Message Details"
        onCancel={closeMessageModal} // Close message modal
      />
    </>
  );
}
